"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var MapPinAlternate = function MapPinAlternate(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M12.5 19.252a.612.612 0 01-.994 0c-.867-1.216-4.503-6.502-4.503-9.746a5 5 0 1110 0c0 3.244-3.635 8.53-4.503 9.746zm-.497-12.87a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(MapPinAlternate);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MapPinAlternate, "MapPinAlternate", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/MapPinAlternate.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/MapPinAlternate.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9NYXBQaW5BbHRlcm5hdGUudHN4Il0sIm5hbWVzIjpbIk1hcFBpbkFsdGVybmF0ZSIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxlQUErRSxHQUFHLFNBQWxGQSxlQUFrRixDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUN0RjtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxDQUFDLEVBQUMsK0tBREo7QUFFRSxJQUFBLElBQUksRUFBQztBQUZQLElBREYsQ0FEc0Y7QUFBQSxDQUF4Rjs7ZUFTZSx1QkFBV0YsZUFBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxlIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBNYXBQaW5BbHRlcm5hdGU6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICA8cGF0aFxuICAgICAgZD1cIk0xMi41IDE5LjI1MmEuNjEyLjYxMiAwIDAxLS45OTQgMGMtLjg2Ny0xLjIxNi00LjUwMy02LjUwMi00LjUwMy05Ljc0NmE1IDUgMCAxMTEwIDBjMCAzLjI0NC0zLjYzNSA4LjUzLTQuNTAzIDkuNzQ2em0tLjQ5Ny0xMi44N2EzLjEyNSAzLjEyNSAwIDEwMCA2LjI1IDMuMTI1IDMuMTI1IDAgMDAwLTYuMjV6XCJcbiAgICAgIGZpbGw9XCJjdXJyZW50Q29sb3JcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihNYXBQaW5BbHRlcm5hdGUpO1xuIl19